import React, { Component } from 'react';
import UserFirstLastNames from '../../../../jsxctl/profile/userfirstlastnames';
import UserPhoneNumbers from '../../../../jsxctl/profile/userphonenumbers';
import UserEmails from '../../../../jsxctl/profile/useremails';
import TranslatorManager from 'ts-translate-js';
import tsRest from 'ts-rest-client';
import cIf from 'classnames';
import { up } from 'ts-util';

const tr = TranslatorManager.boundTR;

const BAD_REQUEST = 1;
const FORBIDDEN = 2;


type CallbackListFormProps = {
    onContentChange?: () => void,
    eventDateId: number
}

type CallbackListFormState = {
    data: CallbackListModel,
    showError: boolean,
    errors: {
        type?: number,
        MissingFields?: string[],
        InvalidEmailFormat?: boolean,
        InvalidPhoneNumberFormat?: boolean,
        InvalidTicketsNumberWanted?: boolean
    },
    showSuccess: boolean
}

type CallbackListModel = {
    FirstName: string,
    LastName: string,
    Email: string,
    Phone: string,
    NumberOfTickets: number | undefined
}

export class CallbackListForm extends Component<CallbackListFormProps, CallbackListFormState> {
    constructor(props) {
        super(props);
        this.state = {
            data: {
                FirstName: "",
                LastName: "",
                Email: "",
                Phone: "",
                NumberOfTickets: undefined
            },
            showError: false,
            errors: {},
            showSuccess: false
        };

        this.onNamesChange = this.onNamesChange.bind(this);
        this.onPhoneNumberChange = this.onPhoneNumberChange.bind(this);
        this.onEmailChange = this.onEmailChange.bind(this);
        this.onTicketsNumberChange = this.onTicketsNumberChange.bind(this);
        this.addUserToCallbackList = this.addUserToCallbackList.bind(this);
    }

    componentDidMount() {
        this.raiseContentChanged();
    }

    componentDidUpdate() {
        this.raiseContentChanged();
    }

    raiseContentChanged() {
        // Set timeout because even though React rendered the tags, they are not yet drawn on the screen.
        setTimeout(function(){
            if(this.props.onContentChange !== undefined) this.props.onContentChange();
        }.bind(this), 0);
    }

    unfillForm() {
        this.setState({
            data: {
                FirstName: "",
                LastName: "",
                Email: "",
                Phone: "",
                NumberOfTickets: undefined
            },
            showError: false,
            errors: {},
            showSuccess: false
        });
    }

    onNamesChange(names) {
        let changes = {
            ["FirstName"]: { $set: names.firstName },
            ["LastName"]: { $set: names.lastName }
        };
        this.setState({data: up(this.state.data, changes)});
    }

    onEmailChange(emails) {
        let changes = {
            ["Email"]: { $set: emails.email }
        };
        this.setState({data: up(this.state.data, changes)});
    }

    onPhoneNumberChange(phoneNumber) {
        let changes = {
            ["Phone"]: { $set: phoneNumber.homePhone }
        };
        this.setState({data: up(this.state.data, changes)});
    }

    onTicketsNumberChange(e) {
        let changes = {
            ["NumberOfTickets"]: { $set: e.target.value }
        };
        this.setState({data: up(this.state.data, changes)});
    }

    async addUserToCallbackList(e) {
        e.preventDefault();
        e.stopPropagation();
        // tsRest.post(`/buyticket/addcustomertocallbacklist/${this.props.eventDateId}`, this.state.data).then(() => {
        //     this.setState({
        //         data: {},
        //         showError: false,
        //         errors: {},
        //         showSuccess: true
        //     })
        // }, error => {
        //     if (error.isBadRequest) {
        //         this.createErrorsMessages(error.body.FieldValidationErrors);
        //     } else if (error.isForbidden) {
        //         this.setState({
        //             showError: true,
        //             errors: {
        //                 type: FORBIDDEN
        //             }
        //         })
        //     }
        // });
        try {
            await tsRest.post(`/buyticket/addcustomertocallbacklist/${this.props.eventDateId}`, this.state.data);
            this.unfillForm();
        } catch (err) {
            if (err.isBadRequest) {
                this.createErrorsMessages(err.body.FieldValidationErrors);
            } else if (err.isForbidden) {
                this.setState({
                    showError: true,
                    errors: {
                        type: FORBIDDEN
                    }
                });
            }
        }
    }

    createErrorsMessages(errors) {
        let missingFields = [];
        let isEmailInvalid = false;
        let isTicketsNumberWantedInvalid = false;
        let isPhoneNumberInvalid = false;

        errors.forEach((fieldError) => {
            switch (fieldError.ErrorName) {
                case "REQUIRED":
                    missingFields.push(fieldError.FieldName);
                    break;
                case "INVALID_FORMAT":
                    if (fieldError.FieldName === "Email") {
                        isEmailInvalid = true;
                    }
                    if (fieldError.FieldName === "Phone") {
                        isPhoneNumberInvalid = true;
                    }
                    break;
                case "INVALID_INT":
                    if (fieldError.FieldName === "NumberOfTickets") {
                        isTicketsNumberWantedInvalid = true;
                    }
                    break;
            }
        });

        this.setState({ 
            showError: true,
            errors: {
                type: BAD_REQUEST,
                MissingFields: missingFields,
                InvalidEmailFormat: isEmailInvalid,
                InvalidPhoneNumberFormat: isPhoneNumberInvalid,
                InvalidTicketsNumberWanted: isTicketsNumberWantedInvalid
            }
        });
    }

    createGenericErrorMessage() {
        return (
            <div className="alert text-center alert-danger">
                <div className="row">
                    <div className="col-xs-12">
                        {tr("Une erreur est survenue. Veuillez réessayer plus tard.")}
                    </div>
                </div>
            </div>
        );
    }

    createEmailErrorMessage() {
        if (this.state.showError && this.state.errors != null) {
            if (this.state.errors.MissingFields.includes("Email"))
                return <span id="helpBlock" className="help-block">{tr("Requis")}</span>;
            if (this.state.errors.InvalidEmailFormat)
                return <span id="helpBlock" className="help-block">{tr("profileedition.emailformat")}</span>;
        }

        return null; 
    }

    createPhoneNumberErrorMessage() {
        if (this.state.showError && this.state.errors != null) {
            if (this.state.errors.MissingFields.includes("Phone"))
                return <span id="helpBlock" className="help-block">{tr("Requis")}</span>;
            if (this.state.errors.InvalidPhoneNumberFormat)
                return <span id="helpBlock" className="help-block">{tr("profileedition.phoneformat")}</span>;
        }

        return null;
    }

    createTicketsNumberWantedError() {
        if (this.state.showError && this.state.errors != null) {
            if (this.state.errors.MissingFields.includes("NumberOfTickets"))
                return <span id="helpBlock" className="help-block">{tr("Requis")}</span>;
            if (this.state.errors.InvalidTicketsNumberWanted)
                return <span id="helpBlock" className="help-block">{tr("Vous devez entrer un nombre")}</span>;
        }

        return null;
    }

    render() {
        let emailErrorMessage, phoneNumberErrorMessage, ticketsNumberWantedErrorMessage, genericErrorMessage;
        let isBadRequest = false;
        if (this.state.showError) {
            if (this.state.errors.type === BAD_REQUEST) {
                isBadRequest = true;
                emailErrorMessage = this.createEmailErrorMessage();
                phoneNumberErrorMessage = this.createPhoneNumberErrorMessage();
                ticketsNumberWantedErrorMessage = this.createTicketsNumberWantedError();
            } else {
                genericErrorMessage = this.createGenericErrorMessage();
            }
        }

        const successMessage =  (
            <h4 className="text-center">{tr("Vous êtes enregistré sur la liste de rappel.")}</h4>
        );

        const form = (
            <div>
                <h4>{tr("Inscrivez vos informations pour que nous puissions vous contacter en cas de supplémentaire.")}</h4>
                <br />
                <UserFirstLastNames 
                    handleOnNamesChange={this.onNamesChange} 
                    firstName={this.state.data.FirstName} 
                    lastName={this.state.data.LastName}
                    showProfileEditionError={isBadRequest}
                />
                <UserPhoneNumbers 
                    handleOnPhoneNumbersChange={this.onPhoneNumberChange} 
                    phoneEvening={this.state.data.Phone}
                    showBothPhoneNumbers={false}
                    showProfileEditionError={isBadRequest}
                    phoneEveningErrorMessage={phoneNumberErrorMessage}
                />
                <UserEmails 
                    handleOnEmailsChange={this.onEmailChange} 
                    isNew={false}
                    email={this.state.data.Email} 
                    emailErrorMessage={emailErrorMessage}
                />
                <div className={cIf({ "has-error": (ticketsNumberWantedErrorMessage != null) && this.state.showError, "form-group": true })}>
                    <label htmlFor="ticketsNumberWanted" className="control-label">{tr("Nombre de billets désirés")}</label>
                    <input 
                        id="ticketsNumberWanted" 
                        className="form-control" 
                        type="text" 
                        value={this.state.data.NumberOfTickets}
                        onChange={this.onTicketsNumberChange} 
                    />
                    {ticketsNumberWantedErrorMessage}
                </div>
                <br />
                {genericErrorMessage}
                <br />
                <div className="btn-toolbar pull-right">
                    <button className="btn btn-primary" onClick={this.addUserToCallbackList}>{tr("Envoyer")}</button>
                </div>
                <div className="clear" />
            </div>
        );

        return (
            <div>
                <div className="well">
                    { this.state.showSuccess ? successMessage : form }
                </div>
            </div>
        );
    }
}